import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from "react-i18next";

interface DeleteCardDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  isDeleting?: boolean;
}

export function DeleteCardDialog({ open, onClose, onConfirm, title, isDeleting }: DeleteCardDialogProps) {
  const { t } = useTranslation("crm");
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-card border-border rounded-2xl max-w-md dark:bg-[#18181B] dark:border-[#3F3F464D]">
        <DialogHeader>
          <DialogTitle className="text-foreground dark:text-white flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-500" />
            {t("detail.deleteTitle")}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground dark:text-neutral-400">
            {t("detail.deleteBody")}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground dark:text-neutral-300">
            Tem certeza que deseja excluir {title ? (
              <>{t("detail.theOpportunity")} <span className="font-medium text-foreground dark:text-white">"{title}"</span></>
            ) : (
              t("detail.thisOpportunity")
            )}?
          </p>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
            className="border-border text-foreground hover:bg-[#F1F5F9] dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-black"
          >
            {t("common.cancel")}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? 'Excluindo...' : 'Excluir'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
